import { Component } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  NavController,
  NavParams,
  ToastController,
  AlertController,
  LoadingController,
} from "ionic-angular";

import { ParticipacaoProvider } from "../../../providers/participacao/partipacao.provider";

import { Evento } from "../../../domain/evento";
import { ReciclagemPage } from "../reciclagem";
import { ContratoProvider } from "../../../providers/contrato/contrato.provider";
import { AnonymizeProvider } from "../../../providers/anonymize/anonymize.provider";
import { Contrato } from "../../../domain/contrato";
import { Participacao } from "../../../domain/participacao";

//@IonicPage()
@Component({
  selector: "page-reciclagem-origem",
  templateUrl: "reciclagem-origem.html",
})
export class ReciclagemOrigemPage {
  evento_aberto: Evento;
  contratos: any;

  searchTerm: string = "";
  searchControl: FormControl;
  searching: any = false;

  buttons: any;

  participacaoId: number;
  participacao: Participacao;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public loading: LoadingController,
    public alertCtrl: AlertController,
    public participacaoProvider: ParticipacaoProvider,
    public contratoProvider: ContratoProvider,
    public anonymizeProvider: AnonymizeProvider
  ) {
    if (
      this.navParams.get("id") !== undefined &&
      this.navParams.get("id") > 0
    ) {
      let load = this.loading.create({ content: "Consultados dados..." });
      this.participacaoId = this.navParams.get("id");
      load.present();

      this.participacaoProvider
        .getById(this.participacaoId)
        .subscribe((result) => {
          this.participacao = result as Participacao;
          this.searchControl = new FormControl();
          this.getEventoAberto();
          load.dismiss();
        });
    } else {
      let toast = this.toastCtrl.create({ duration: 1500 });
      // let self = this;
      toast.setMessage(
        "Selecione um participante antes de selecionar a sua origem!"
      );
      toast.present();
      toast.onDidDismiss(() => {
        // self.navCtrl.setRoot("HomePage");
      });
    }
  }

  ionViewDidLoad() {
    this.searchByNUC();
  }

  onSearchInput() {
    this.searching = true;
  }

  searchByNUC() {
    if (this.searchTerm != "") {
      this.contratoProvider.searchExcludingType(this.searchTerm, 4).subscribe((result) => {
        this.contratos = result.json().contratos as Contrato[];
        this.searching = false;
      });
    } else {
      this.contratos = false;
      this.searching = false;
    }
  }

  buttonClicked(contratoOrigem: Contrato): void {
    this.navCtrl.push(ReciclagemPage, {
      id: this.participacaoId,
      origem: contratoOrigem.id,
    });
  }

  naoInformarOrigem() {
    let toast = this.toastCtrl.create({ duration: 3000 });
    let self = this;
    self.navCtrl.push(ReciclagemPage, {
      id: this.participacaoId,
      origem: null, // Corrigido: null indica reciclagem própria (sem doador)
    });
    toast.setMessage("Você optou por não informar a origem da reciclagem.");
    toast.present();

    return false;
  }

  /* Privates  */
  private getEventoAberto(): any {
    if (localStorage.getItem("evento_aberto")) {
      this.evento_aberto = JSON.parse(localStorage.getItem("evento_aberto"));
      return true;
    } else {
      let toast = this.toastCtrl.create({ duration: 1500 });
      let self = this;
      toast.setMessage("Selecione um evento antes de continuar!");
      toast.present();
      toast.onDidDismiss(() => {
        self.navCtrl.setRoot("HomePage");
      });
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/reciclagem/reciclagem-origem/reciclagem-origem.ts